import styled from 'styled-components';

import { theme } from '@/theme';

export const NavbarContainer = styled.div`
  width: 100%;
  background-color: ${theme.colors.primary};
  display: flex;
  justify-content: space-between;
  padding: 0;
  height: 64px; /* Fixed height as requested */
`;

export const TabList = styled.ul`
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0 20px;
  height: 100%;
  overflow-x: auto;
`;

export const TabItem = styled.li<{ isActive: boolean }>`
  margin-right: 30px;
  text-align: center;
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${(props) => (props.isActive ? 'black' : 'transparent')};
    transition: background-color 0.2s ease;
  }
`;

export const TabButton = styled.button`
  background: none;
  border: none;
  padding: 0 5px;
  color: black;
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
  font-family: ${({ theme }) =>
    theme.fontFamilies?.italianPlate || 'italianPlate'};
  font-size: ${({ theme }) => theme.fontSizes?.p0 || '14px'};
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  line-height: ${({ theme }) => theme.spacing?.(2.75) || '22px'};
  height: 100%;

  &:hover {
    opacity: 0.8;
  }
`;

export const BackButton = styled(TabButton)`
  display: flex;
  align-items: center;
  font-weight: 500;
  color: black;
  position: relative;
  z-index: 1;
  margin-right: 15px;

  &::before {
    content: '←';
    margin-right: 8px;
    font-size: 18px;
  }

  &:hover {
    color: ${theme.colors.secondary};
  }
`;

// Language switcher styles
export const LanguageSwitcherContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding-right: 20px;
  position: relative;
`;

export const LanguageSelect = styled.select`
  appearance: none;
  background-color: transparent;
  border: none;
  padding: 0 22px 0 10px;
  margin: 0;
  cursor: pointer;
  outline: none;
  font-family: ${({ theme }) =>
    theme.fontFamilies?.italianPlate || 'italianPlate'};
  font-size: ${({ theme }) => theme.fontSizes?.p0 || '14px'};
  font-weight: 400;
  text-transform: uppercase;
  color: black;

  &::-ms-expand {
    display: none;
  }
`;

export const ArrowIcon = styled.span`
  position: absolute;
  right: 15px;
  pointer-events: none;
  font-size: 8px;
  line-height: 1;
  top: 50%;
  transform: translateY(-50%);
`;
